import { render, staticRenderFns } from "./SearchFilters.vue?vue&type=template&id=70fa3458&scoped=true&"
import script from "./SearchFilters.vue?vue&type=script&lang=ts&"
export * from "./SearchFilters.vue?vue&type=script&lang=ts&"
import style0 from "./SearchFilters.vue?vue&type=style&index=0&id=70fa3458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa3458",
  null
  
)

export default component.exports